/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyboxTip.vue?vue&type=template&id=15628632&scoped=true"
import script from "./popLuckyboxTip.vue?vue&type=script&lang=js"
export * from "./popLuckyboxTip.vue?vue&type=script&lang=js"
import style0 from "./popLuckyboxTip.vue?vue&type=style&index=0&id=15628632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15628632",
  null
  
)

export default component.exports